var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"ca-content"},[_c('router-link',{staticClass:"ca-link",attrs:{"to":"/main"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ca-content"},[_c('div',{staticClass:"ca-bg"}),_c('div',{staticClass:"ca-box"},[_c('div',{staticClass:"ca-a"},[_vm._v("Cassandra-Web")])])])
}]

export { render, staticRenderFns }